import { render } from "./AccountProfile.vue?vue&type=template&id=dffeef5a"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__